import Instance from "../../../Axios";

const GetPlusParceiros = () => async (dispatch) => {
  await Instance()
    .get(`/plus/adesoes/data/parceiros`)
    .then(({ data }) => {
      dispatch({ type: "GET_PLUS_PARCEIROS", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetPlusParceiros;
